import { useQuery } from "@tanstack/react-query"
import { trpcClient } from "@tokenterminal/core/utils/trpc"

type UseProductsListProps = {
  dataIds?: string[]
}

export const useProductsList = ({ dataIds }: UseProductsListProps = {}) => {
  const params = dataIds ? { data_ids: dataIds } : {}
  return useQuery({
    queryKey: ["products-list", dataIds],
    queryFn: async () => {
      const result = await trpcClient.products.getProducts.query(params)
      return result.data
    },
    staleTime: 1000 * 60 * 10,
  })
}
